import { render, staticRenderFns } from "./PremiumRequired.vue?vue&type=template&id=fdacb0c2"
import script from "./PremiumRequired.vue?vue&type=script&lang=js"
export * from "./PremiumRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports